import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

// Pushes a backoffice-prepared flow JSON (publish/prepare or rollback/prepare) to the operator's kiosks.
// The JSON is pushed unchanged so the kiosks get exactly what the backoffice validated and will record.
export class PushKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext, flowJson: string): Promise<void> {
    assertOperator(ctx);
    if (!flowJson?.trim()) {
      throw new Error('There is no prepared flow to push');
    }
    return this.repository.pushFlow(ctx.operatorId, flowJson);
  }
}
